<template>
  <div :class="btnLink ? 's-button-link' : 's-button'">
    <a :href="btnLink || null">
      <s-icon :iconFont="iconFont" v-if="iconFont"></s-icon>
      <img :src="iconImageUrl" v-if="iconImage" alt="icon" />
      <span class="s-button-slot">
        <slot></slot>
      </span>
      <s-icon class="s-button-icon-after" :iconFont="iconFontAfter" v-if="iconFontAfter"></s-icon>
      <img :src="iconImageUrlAfter" v-if="iconImageAfter" alt="icon" />
    </a>
  </div>
</template>


<script setup>
import { toRefs, ref, watchEffect } from 'vue'
import SIcon from "../components/SIcon.vue";
import {useDynamicImageLoader} from "../helper/useDynamicImageLoader";


const props = defineProps({
  btnLink: {
    type: String,
    default: ''
  },
  iconImage: {
    type: String,
    default: ''
  },
  iconFont: {
    type: String,
    default: ''
  },
  iconImageAfter: {
    type: String,
    default: ''
  },
  iconFontAfter: {
    type: String,
    default: ''
  }
})


const { iconImage, iconImageAfter } = toRefs(props)

// const getSvgIcons = async (icon) => {
//   try {
//     let [imageName] = icon.value.split('.')
//     const module = imageName ? await import(`${imageName}.svg?url`) : ''
//     return module?.default || ''
//   } catch (error) {
//     console.error(error)
//     return ''
//   }
// }

const iconImageUrl = ref('')
const iconImageUrlAfter = ref('')

useDynamicImageLoader(iconImage, iconImageUrl)
useDynamicImageLoader(iconImageAfter, iconImageUrlAfter)

// watchEffect(async () => {
//   if(!iconImage.value) return
//   iconImageUrl.value = await getSvgIcons(iconImage)
// })
//
// watchEffect(async () => {
//   if(!iconImageAfter.value) return
//   iconImageUrlAfter.value = await getSvgIcons(iconImageAfter)
// })
</script>
